import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import ActionButton from 'components/buttons/action-button/ActionButton';

applyTranslations(require('./i18n/profile-creation-step-intro.i18n.json'));

type Props = {
  onSubmit: () => void
};

class ProfileCreationStepIntro extends React.PureComponent<Props> {
  handleNext = (): void => {
    const { onSubmit } = this.props;

    onSubmit();
  };

  render() {
    return (
      <section
        className="profile-creation-step-intro"
        data-qa="profile-creation-step-intro"
      >
        <div>&nbsp;</div>
        <div className="profile-creation-step-intro__content">
          <div className="profile-creation-step-intro__heading">
            {__t('profile_creation_step_intro.step_intro_heading')}
          </div>
          <div className="profile-creation-step-intro__message">
            {__t('profile_creation_step_intro.step_intro_message_main')}
          </div>
          <div className="profile-creation-step-intro__message">
            {__t('profile_creation_step_intro.step_intro_message_sub')}
          </div>
        </div>
        <div className="profile-creation-step-intro__button">
          <ActionButton
            color="primary"
            onClick={this.handleNext}
          >
            {__t('profile_creation_step_intro.button_begin')}
          </ActionButton>
        </div>
      </section>
    );
  }
}

export default ProfileCreationStepIntro;
